import React, { SyntheticEvent } from "react";

import NoPhotoImg from "public/images/no-photo.png";

// import { CircularProgress } from "@mui/material";

type PropTypes = {
  spinnerAbsoluteCenter?: boolean;
  children: React.ReactElement;
};

export const InjectOnLoadSpinner = ({
  children,
}: // spinnerAbsoluteCenter,
PropTypes) => {
  // const [isLoaded, setIsLoaded] = React.useState(false);

  // const onLoad = React.useCallback(() => {
  //   setIsLoaded(true);
  // }, []);

  const onError = React.useCallback(
    (e: SyntheticEvent<HTMLImageElement, Event>) => {
      const picturePlug = (NoPhotoImg as StaticAssetWithSrc).src;

      // setIsLoaded(true);
      e.currentTarget.src = picturePlug;
    },
    [],
  );

  return (
    <>
      {React.cloneElement(children, {
        // onLoad,
        onError,
        style: {
          // display: isLoaded ? "unset" : "none",
          ...children.props.style,
        },
      })}
      {/* {!isLoaded ? (
        <CircularProgress
          className={
            spinnerAbsoluteCenter
              ? "absolute left-[calc(50%_-_20px)] top-[calc(50%_-_20px)]"
              : undefined
          }
        />
      ) : null} */}
    </>
  );
};
